import React, { useState } from "react";
import { Button, Col, Divider, Popover, Row } from "antd";
import styles from "./NftCard.module.css";
import dark from "./NftCardDark.module.css";

const NftCard = ({ val, onSelect, onUnselect, isSelected, erc721,theme }) => {
  const followHandler = () => {};


  const handleSelect = () => {
    onSelect(val);
  };

  const handleUnselect = () => {
    onUnselect(val);
  };

  return (
    <div
      className={`${theme ? "card" : "card-dark"} ${
        isSelected ? "selected-card" : ""
      }`}
    >
      <div
        className={
          theme ? "card__image-container" : "card__image-container-dark"
        }
      >
        <img
          className="card-image"
          src={val.image.originalUrl}
          alt="Detailed image description would go here."
        />
      </div>
      {isSelected && (
        <div className="card__content">
          <Row className={theme ? styles.firstRow : dark.firstRow}>
            <p>{val.name}</p>
          </Row>
          <Divider
            style={{
              margin: "0",
              backgroundColor: theme ? "inherit" : "#7773",
            }}
          />
          <Row className={theme ? styles.thirdRow : dark.thirdRow}>
            <p>Token Type</p>
          </Row>
          <Row className={theme ? styles.fourRow : dark.fourRow}>
            <p>{val.tokenType}</p>
          </Row>
          <Divider style={{ margin: 0 }} />
         {!erc721 && <Row className={styles.fifthRow}>
            <Button className={styles.unSelectButton} onClick={handleUnselect}>Unselect</Button>
          </Row>}
        </div>
      )}
      {!isSelected && (
        <div className="card__content">
          <Row className={theme ? styles.firstRow : dark.firstRow}>
            <p>{val.name}</p>
          </Row>
          <Divider
            style={{
              margin: "0",
              backgroundColor: theme ? "inherit" : "#7773",
            }}
          />
          <Row className={theme ? styles.thirdRow : dark.thirdRow}>
            <p>Token Type</p>
          </Row>
          <Row className={theme ? styles.fourRow : dark.fourRow}>
            <p>{val.tokenType}</p>
          </Row>
          <Divider
            style={{
              margin: "0",
              backgroundColor: theme ? "inherit" : "#7773",
            }}
          />
         {!erc721 && <Row className={styles.fifthRow}>
            <Button className={styles.button} onClick={handleSelect}>Select</Button>
          </Row>}
        </div>
      )}
    </div>
  );
};

export default NftCard;
